import { Component, EventEmitter, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { LoaderComponent } from './shared/loader.component';
import {
  LOCAL_STORAGE_KEYS,
  LocalStorageItemsService,
} from './services/local-storage-items.service';
import { HttpClient } from '@angular/common/http';
import { ApiUrls } from './shared/apiurls';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private destroyEvents: EventEmitter<boolean> = new EventEmitter();
  constructor(
    private localStorageService: LocalStorageItemsService,
    private http: HttpClient,
    private router: Router,
    private modalService: NgbModal,
  ) {}
  ngOnInit(): void {
    window.addEventListener('storage', (event) => {
      if (event.key === 'logout-event') {
        console.log('Detected logout in another tab.');
        this.modalService.dismissAll();
        window.location.reload();
        window.close();
      }
    });
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const currentUrl = event.urlAfterRedirects;
        console.log(currentUrl, 'currentUrl');
        if (currentUrl !== '/') {
          this.localStorageService.startTimerToCheckTimeOut();
        }
      }
    });
  }
}
